import { z } from 'zod'

const jsonResponseSchema = z.object({}).passthrough()

export const billingSubscriptionWriteCreateResponseSchema = jsonResponseSchema
export const billingSubscriptionWriteUpgradeResponseSchema = jsonResponseSchema
export const billingSubscriptionWriteCancelResponseSchema = jsonResponseSchema
export const billingSubscriptionWritePauseResponseSchema = jsonResponseSchema
export const billingSubscriptionWriteResumeResponseSchema = jsonResponseSchema

export type BillingSubscriptionWriteCreateResponse = z.infer<typeof billingSubscriptionWriteCreateResponseSchema>
export type BillingSubscriptionWriteUpgradeResponse = z.infer<typeof billingSubscriptionWriteUpgradeResponseSchema>
export type BillingSubscriptionWriteCancelResponse = z.infer<typeof billingSubscriptionWriteCancelResponseSchema>
export type BillingSubscriptionWritePauseResponse = z.infer<typeof billingSubscriptionWritePauseResponseSchema>
export type BillingSubscriptionWriteResumeResponse = z.infer<typeof billingSubscriptionWriteResumeResponseSchema>
